export default "__VITE_PUBLIC_ASSET__45cb24d2__"